import styled, { css } from 'styled-components';

export const arrowWidth = (evo?: boolean): number => (evo ? 68 : 60);

export const ArrowContainer = styled.div<{ isRightArrow?: boolean; externalHeaderEnabled: boolean; $evo?: boolean }>`
  width: ${({ $evo }) => arrowWidth($evo)}px;
  height: 100%;
  position: absolute;
  z-index: 3;
  display: flex;
  align-items: center;

  ${({ isRightArrow, externalHeaderEnabled }) =>
    isRightArrow
      ? css`
          background: linear-gradient(270deg, white 50%, transparent 100%);
          ${externalHeaderEnabled && 'background: linear-gradient(270deg, #f5f5f5 50%, transparent 100%);'}
          right: 0;
          justify-content: right;

          button {
            margin-right: 8px;
          }
        `
      : css`
          background: linear-gradient(90deg, white 50%, transparent 100%);
          ${externalHeaderEnabled && 'background: linear-gradient(90deg, #f5f5f5 50%, transparent 100%);'}
          left: 0;
          justify-content: left;

          button {
            margin-left: 8px;
          }
        `}

  ${({ $evo, isRightArrow, theme }) =>
    $evo &&
    css`
      background: linear-gradient(
        ${isRightArrow ? '270deg' : '90deg'},
        ${theme.kallisto.color.background.static.backgroundPage} calc(100% - 24px),
        transparent
      );
    `}
`;

export const ArrowCircle = styled.button<{ noShadow?: boolean; $evo?: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.2s;
  background-color: #fff;
  cursor: pointer;
  box-shadow: ${({ noShadow }) => (noShadow ? 'none' : ({ theme }): string => theme.kallisto.shadow.mediumDownShadow)};

  &:hover {
    box-shadow: ${({ noShadow }) => (noShadow ? 'none' : ({ theme }): string => theme.kallisto.shadow.largeDownShadow)};
  }

  ${({ $evo, theme }) =>
    $evo &&
    css`
      border: 1px solid ${theme.kallisto.color.border.static.borderNeutral};
      background-color: ${theme.kallisto.color.background.static.backgroundLayer02};
    `}
`;
